import { apiHeader } from "@bisom/web_package";
import axios from "@/utils/axiosInterceptors";
import { getApiV3WithDivision } from "@/utils/apiBisomV3";

const apiEndpoint = async () => {
  return await `${getApiV3WithDivision()}/user_preferences`;
};

const getUserPref = async () => {
  try {
    const headerParams: object = {
      ...apiHeader(),
    };
    const url = await apiEndpoint();

    const response = await axios.get(url, headerParams);

    return Promise.resolve(response.data);
  } catch (error) {
    return Promise.reject(error);
  }
};

const postUserPref = async (userPref: object) => {
  try {
    const headerParams: object = {
      ...apiHeader(),
    };
    const url = await apiEndpoint();

    const response = await axios.post(url, userPref, headerParams);

    return Promise.resolve(response.data);
  } catch (error) {
    return Promise.reject(error);
  }
};

export default {
  getUserPref,
  postUserPref,
};
